import './ModelList.css';const modelList = "_modelList_lu5ki_1";
const modelList__title = "_modelList__title_lu5ki_27";
const modelList__brandHeader = "_modelList__brandHeader_lu5ki_88";
const modelList__brandTitle = "_modelList__brandTitle_lu5ki_97";
const modelList__brandDescription = "_modelList__brandDescription_lu5ki_150";
const styles = {
  modelList,
  "modelList__checkbox--loading": "_modelList__checkbox--loading_lu5ki_9",
  modelList__title,
  modelList__brandHeader,
  modelList__brandTitle,
  modelList__brandDescription
};
export {
  styles as default,
  modelList,
  modelList__brandDescription,
  modelList__brandHeader,
  modelList__brandTitle,
  modelList__title
};
